(() => {
  const getSlideFlavor = (swiper) => {
    const slide = swiper.slides[swiper.activeIndex];
    if (slide?.dataset?.flavor) return slide.dataset.flavor;

    if (typeof swiper.realIndex === "number") {
      const flavors = [
        ...swiper.el.querySelectorAll(".swiper-slide[data-flavor]:not(.swiper-slide-duplicate)"),
      ].map((el) => el.dataset.flavor);

      if (flavors[swiper.realIndex]) {
        return flavors[swiper.realIndex];
      }
    }

    return null;
  };

  const setHomeZoneBackground = (flavor) => {
    if (!flavor) return;
    document.querySelectorAll(".alfa-home-zone__bg").forEach((img) => {
      img.classList.toggle("is-active", img.dataset.flavor === flavor);
    });
  };

  const resizeHomeZoneBackground = () => {
    if (!document.body.classList.contains("template-index")) return;

    const anchor = document.querySelector(".alfa-home-zone__anchor");
    const bgWrap = document.querySelector(".alfa-home-zone__bg-wrap");
    if (!anchor || !bgWrap) return;

    const headerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-height")
      ) || 86;

    const anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
    let endY = anchorTop + anchor.offsetHeight;

    const mission = document.querySelector(".section-alfa-mission");
    if (mission) {
      endY = mission.getBoundingClientRect().top + window.scrollY;
    } else {
      document.querySelectorAll(".alfa-home-zone__panel").forEach((panel) => {
        const panelBottom =
          panel.getBoundingClientRect().top + window.scrollY + panel.offsetHeight;
        if (panelBottom > endY) endY = panelBottom;
      });
    }

    bgWrap.style.top = `-${headerHeight}px`;
    bgWrap.style.height = `${Math.max(endY - anchorTop + headerHeight, 0)}px`;
  };

  let resizeFrame;
  const scheduleHomeZoneResize = () => {
    if (resizeFrame) cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(resizeHomeZoneBackground);
  };

  const initAlfaHeroCarousel = (root) => {
    if (!root || root.swiper) return;

    const autoplay = root.dataset.autoplay === "true";
    const duration = Number(root.dataset.duration || 6) * 1000;
    const loop = root.dataset.loop === "true";

    const params = {
      slidesPerView: 1,
      speed: 500,
      watchOverflow: true,
      pagination: {
        el: root.querySelector(".swiper-pagination"),
        clickable: true,
      },
      on: {
        init(swiper) {
          setHomeZoneBackground(getSlideFlavor(swiper));
          scheduleHomeZoneResize();
        },
        slideChange(swiper) {
          setHomeZoneBackground(getSlideFlavor(swiper));
        },
      },
    };

    if (loop) {
      params.loop = true;
    }

    if (autoplay) {
      params.autoplay = {
        delay: duration,
        disableOnInteraction: true,
      };
    }

    // eslint-disable-next-line no-undef
    root.swiper = new Swiper(root, params);
  };

  const initAll = () => {
    document
      .querySelectorAll(".alfa-hero-carousel__slider")
      .forEach(initAlfaHeroCarousel);
    scheduleHomeZoneResize();
  };

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("resize", scheduleHomeZoneResize);
  window.addEventListener("load", scheduleHomeZoneResize);

  document.addEventListener("shopify:section:load", (event) => {
    const slider = event.target?.querySelector?.(".alfa-hero-carousel__slider");
    if (slider) initAlfaHeroCarousel(slider);
    scheduleHomeZoneResize();
  });

  document.addEventListener("shopify:section:unload", scheduleHomeZoneResize);
  document.addEventListener("shopify:section:reorder", scheduleHomeZoneResize);
})();
